import React from "react";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import styles from "./Error.scss";

class Error extends React.Component {
  render() {
    const { common } = this.props;

    return (
      <div className={styles.errorBox}>
        {common.error && <Alert bsStyle="danger">{common.error}</Alert>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    common: state.common
  };
};

export default connect(mapStateToProps)(Error);



// WEBPACK FOOTER //
// ./src/components/common/error/Error.js